import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { useTranslations } from '../../locales/useTranslations';

const DienstleistungenFAQ = () => {
    const { t } = useTranslations();
    return (
        <section className="faq-area ptb-70 bg-color-f4f5fe" >
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7 col-md-12">
                        <div className="faq-accordion">
                            <h2><span>{t('dienstleistungen_faq_title')}</span></h2>

                            <div className="native-accordion">
                                <details open>
                                    <summary>
                                        {t('dienstleistungen_faq_question_1')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('dienstleistungen_faq_answer_1')}
                                        </p>
                                    </div>
                                </details>

                                <details>
                                    <summary>
                                        {t('dienstleistungen_faq_question_2')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('dienstleistungen_faq_answer_2')}
                                        </p>
                                    </div>
                                </details>

                                <details>
                                    <summary>
                                        {t('dienstleistungen_faq_question_3')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('dienstleistungen_faq_answer_3')}
                                        </p>
                                    </div>
                                </details>

                                <details>
                                    <summary>
                                        {t('dienstleistungen_faq_question_4')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('dienstleistungen_faq_answer_4')}
                                        </p>
                                    </div>
                                </details>

                                <details>
                                    <summary>
                                        {t('dienstleistungen_faq_question_5')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('dienstleistungen_faq_answer_5')}
                                        </p>
                                    </div>
                                </details>

                                <details>
                                    <summary>
                                        {t('dienstleistungen_faq_question_6')}
                                    </summary>
                                    <div className="accordion-content">
                                        <p>
                                            {t('dienstleistungen_faq_answer_6')}
                                        </p>
                                    </div>
                                </details>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-5 col-md-12">
                        <div className="faq-image">
                            <Player
                                autoplay
                                loop
                                src="/images/lottie/faq.json"
                                style={{ height: '300px' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default DienstleistungenFAQ;